// import request from '@/utils/request';
import { history } from 'umi';
import { getToken } from '@/utils/token';
import qs from 'qs';
import EventTracing from '@eventtracing/web';
import webStorage from '@/utils/storageManager';
import { removeItemExcludes } from '@/utils/storageManager';
import { LANG_MAP } from '@/constants';
import { MENU_AUTH } from '@/menusAuth';
// 埋点的初始化配置

EventTracing.init({
  globalParams: {},
  reportLogs: ({ logs }) => {
    if (logs && logs.length > 0) {
      // 调用函数以开始执行fetch请求
      fetchData(logs);
    }
    // 浏览器端日志上报方式，通过发送网络请求上报
    // fetch...
  },
});
function utf8ToBase64(str) {
  return encodeURIComponent(btoa(unescape(encodeURIComponent(str))));
}
async function fetchData(logs) {
  for (const params of logs) {
    // eslint-disable-next-line no-underscore-dangle
    const p = params._plist[0]?._oid;
    if (
      params.event !== '_ev' &&
      !(
        (params.event === '_pv' || params.event === '_pd') &&
        p === 'page_system_layout'
      )
    ) {
      if (params._elist && params._elist[0]?.initUrl) {
        const { initUrl, ...filterData } = params._elist[0];

        params._elist[0] = { ...filterData };
        params.params._url = initUrl;
      }
      if (params._plist && params._plist[0]?.initUrl) {
        const { initUrl, ...filterData } = params._plist[0];

        params._plist = [{ ...filterData }];
        params.params._url = initUrl;
        const userid = webStorage.get('USER')?.id;
        const tenantId = webStorage.get('TENANT_ID');
        params.params.userid = userid;
        params.params.tenant_id = tenantId;
      }
      try {
        const base64Params = utf8ToBase64(JSON.stringify(params));
        const apiUrl = `${process.env.TRACING_API}/ct.gif?ak=${process.env.TRACING_KEY}&log=${base64Params}`;
        console.log('[曙光日志上报]:', '网络请求params', params, apiUrl);

        // 创建一个新的Image对象
        const trackingImage = new Image();
        // 通过设置Image对象的src属性来发送GET请求
        trackingImage.src = apiUrl;
        trackingImage.setAttribute('Content-Type', 'image/gif'); // 设置请求头
      } catch (error) {
        console.log('error', error);
      }
    }
  }
}
/**
 * 该配置是一个 async 的 function。会在整个应用最开始执行，返回值会作为全局共享的数据。
 * Layout 插件、Access 插件以及用户都可以通过 useModel('@@initialState') 直接获取到这份数据。
 */
export async function getInitialState() {
  //   const data = request('user', {
  //     method: 'GET',
  //     // params: values,
  //   });
  //   return data;
  return null;
}

// export function patchRoutes({ routes }) {
//   routes.unshift({
//     path: '/foo',
//     exact: true,
//     component: require('@/pages/index').default,
//   });
// }

/**
 * 覆写 render。
 * 比如用于渲染之前做权限校验，
 */
export function render(oldRender) {
  // const { pathname, search } = history.location;
  // fetch('/api/auth').then((auth) => {
  //   if (auth.isLogin) {
  //     oldRender();
  //   } else {
  //     history.push('/login');
  //   }
  // });
  // 设定语言
  // localeConfig.setLocale(localeConfig.getLocale());

  // if (pathname.includes('/login')) {
  //   // webStorage.delete('USER');
  //   const { lang } = qs.parse(search, {
  //     ignoreQueryPrefix: true,
  //   });
  //   if (!lang) {
  //     const storageLang = webStorage.get('LANG');
  //     const loginLang = !LANG_MAP[storageLang] ? LANG_MAP.default : storageLang;
  //     history.replace(`/login?lang=${loginLang}`);
  //   }
  //   return oldRender();
  // }
  if (!getToken()) {
    history.replace(localeConfig.getPathWithLocale('/login'));
    return oldRender();
  }

  return oldRender();
}

/**
 * onRouteChange({ routes, matchedRoutes, location, action })
 * 在初始加载和路由切换时做一些事情。
 */
export function onRouteChange({ location, action }) {
  const { pathname } = location;
  // const { lang } = qs.parse(search, {
  //   ignoreQueryPrefix: true,
  // });

  // lang && localeConfig.setLocale(lang);

  // 设定语言
  localeConfig.setLocale(localeConfig.getLocale());

  if (pathname === '/login') {
    console.log('💢felix => onRouteChange => login', pathname);
    removeItemExcludes([
      'LANG',
      'AUTHORIZATION',
      'TOKEN_INFO',
      'REFRESH_TOKEN',
      'umi_locale',
    ]);
    action !== 'REPLACE' && history.replace(localeConfig.getPathWithLocale());
    return false;
  }

  // 获取菜单配置
  const menuConfig = webStorage.get('URL_MENU');
  // 用户菜单权限
  const userAuths = webStorage.get('USER')?.authorities || [];
  // if (!menuConfig || !userAuths || userAuths.length === 0) {
  //   action !== 'REPLACE' &&
  //     history.replace(localeConfig.getPathWithLocale('/login'));
  //   return false;
  // }

  if (pathname === '/') {
    const defaultPath = userAuths.includes(
      MENU_AUTH.MENU_MEMBERS_BEHAVIOR_BOARD,
    )
      ? '/ec/dashboard'
      : '/blank';
    history.replace(localeConfig.getPathWithLocale(defaultPath));
    return false;
  }

  const excludePaths = [
    '/login',
    '/404',
    '/403',
    '/demo',
    '/my_task',
    '/blank',
  ];
  const menuAuth = menuConfig?.[pathname]?.auth;
  if (
    !excludePaths.includes(pathname) &&
    !pathname.includes('/bre') &&
    !pathname.includes('/public') &&
    menuAuth &&
    !userAuths.includes(menuAuth)
  ) {
    action !== 'REPLACE' &&
      history.replace(localeConfig.getPathWithLocale('/403'));
    return false;
  }

  action !== 'REPLACE' && history.replace(localeConfig.getPathWithLocale());
}

//配置 dva 创建时的参数。
export const dva = {
  config: {
    // onAction: createLogger(),
    // 统一处理错误
    onError(e) {
      e.preventDefault();
      console.error('dva error:', e.message);
    },
  },
};

const localeConfig = {
  umiLangMap: {
    en: 'en-US',
    cn: 'zh-CN',
  },
  getLocale() {
    const { search } = history.location;
    const { lang } = qs.parse(search, {
      ignoreQueryPrefix: true,
    });
    return lang ?? webStorage.get('LANG') ?? LANG_MAP.default;
  },
  setLocale(lang) {
    lang && webStorage.set('LANG', lang);
  },
  getPathWithLocale(pt) {
    const { search, pathname } = history.location;
    const finalPath = pt ?? pathname;
    const params = qs.parse(search, {
      ignoreQueryPrefix: true,
    });
    params.t = new Date().getTime();
    const storageLang = webStorage.get('LANG');
    params.lang = !LANG_MAP[storageLang] ? LANG_MAP.default : storageLang;
    const path = `${finalPath}?${qs.stringify(params)}`;
    console.log('💢felix => getPathWithLocale => path', path);
    return path;
  },
};
